<template>
    <div class="footer">
        <img class="center footer-image" alt="Woodburn logo" src="../assets/Woodburn-Press-Logo-white.png">
            <div class="footer-container">
            <a class="footer-text" href="https://www.woodburnpress.com/privacy-policy" target="_blank">Privacy Policy</a>
            <span class="footer-text"> 	&#124; </span>
            <a class="footer-text" href="https://www.woodburnpress.com/terms-and-conditions" target="_blank">Terms and Conditions</a>
            <p class="footer-text">Copyright <copyrigt-icon :color="this.color" :size="this.size"></copyrigt-icon> {{new Date().getFullYear()}}  Woodburn Press. All rights reserved. </p>
        </div>
    </div> 
</template>

<script>
import CopyrightIcon from './CopyrightIcon';

export default {
    name: 'CopyrightFooter',

    components:{
        "copyrigt-icon": CopyrightIcon
    },
    
    data(){
        return{
            color: "#FFFFFF",
            size: 1
        }
    }
}
</script>

<style scoped>

    .center {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    
    .footer{
        background-color: #A9A9A9;
        height: 175px !important;
        padding: 0px;
        margin: 0px;
        margin-top: 75px;
        text-align: center;
        width: 100%;
    }
    
    .footer-container{
        margin-top: -30px;
    }

    .footer-image{
        -webkit-transform: scale(0.4); /* Saf3.1+, Chrome */
        -moz-transform: scale(0.4); /* FF3.5+ */
        -ms-transform: scale(0.4); /* IE9 */
        -o-transform: scale(0.4); /* Opera 10.5+ */
        transform: scale(0.4); /* IE6–IE9 */
        margin-top: -30px;
    }

    .footer-text{
        color: #FFFFFF;
        text-decoration: none;
    }
</style>